import ScriptPage from "./ScriptPage"

export default ScriptPage